import { BuilderActionValidationSummaryModel } from "./builder-action-validation-summary.model";
import { BuilderBaseValidationSummaryModel } from "./builder-base-validation-summary.model";
import { BuilderSendGroupValidationSummaryModel } from "./builder-sendgroup-validation-summary.model";

/**
 * MAIN model containing validations for every step of the Wizard/Builder
 */
export class BuilderValidationSummaryModel extends BuilderBaseValidationSummaryModel {
    /**
     * Step 1 - Document validation
     */
    documentValidationSummary: BuilderBaseValidationSummaryModel = new BuilderBaseValidationSummaryModel();
    /**
     * Step 2 - Person validation
     */
    personValidationSummary: BuilderBaseValidationSummaryModel = new BuilderBaseValidationSummaryModel();
    /**
     * Step 3 - Action validation
     */
    actionValidationSummary: BuilderActionValidationSummaryModel = new BuilderActionValidationSummaryModel();
    /**
     * Step 4 - SendGroup validation
     */
    sendGroupValidationSummary: BuilderSendGroupValidationSummaryModel = new BuilderSendGroupValidationSummaryModel();
}